import React, { useEffect , useContext , useRef , useMemo} from "react";
import { Row , Select , Col , DatePicker , Button , Form} from 'antd';
import { getOriginCities , getDestinationCities , fetchSchedules } from './../../../actions/home.action';
import { originsSelector,originSupportedDestinationsSelector } from './../../../selector/home.selector';
import { isValid, isValidArray } from './../../../utils/utilities';
import {  getAPIDateFormat } from './../../../utils/date.utils';
import { useDispatch,useSelector } from "react-redux";
import {
    SwapOutlined
  } from '@ant-design/icons';
import { DeviceContext } from './../../device-provider/device-provider';
import moment from "moment";
import { loadingAction } from './../../../actions/loading-actions';


const { Option } = Select;

const renderOrigins=(origins)=>
{
    let originsArray=[];
    if(isValidArray(origins)&&origins.length>0){
        origins.forEach(element => {
            if(isValid(element)&&isValid(element.city_name)){
                originsArray.push(<Option value={element.city_name}>{element.city_name}</Option>)
            }
        });
    }
    return originsArray;
}

const renderDestinations=(destinations)=>
{
    let destiArray=[];
    if(isValidArray(destinations)&&destinations.length>0){
        destinations.forEach(element => {
            if(isValid(element)&&isValid(element.city_name)){
                destiArray.push(<Option value={element.city_name}>{element.city_name}</Option>)
            }
        });
    }
    return destiArray;
}

/*
  Builds a lookup of lowercased city name -> lowercased alias name
  from the city objects returned by /api/originCities & /api/destinationCities
*/
const buildCityAliasMap=(...cityLists)=>
{
    let map={};
    cityLists.forEach(list => {
        if(isValidArray(list)){
            list.forEach(item => {
                if(item&&isValid(item.city_name)){
                    map[item.city_name.toLowerCase()] = isValid(item.alias_city_name)?item.alias_city_name.toLowerCase():'';
                }
            });
        }
    });
    return map;
}

/*
  Matches the typed input against both the city name and its alias name,
  while the dropdown still displays only the city name
*/
const cityFilterOption=(aliasMap)=>(input,option)=>
{
    let query=(input||'').toLowerCase();
    let cityName=(option.value||'').toString().toLowerCase();
    let aliasName=aliasMap[cityName]||'';
    return cityName.indexOf(query)>=0||aliasName.indexOf(query)>=0;
}

export const SearchScheduleComponent = ({
    origin=null,
    destination=null,
    date=null,
    isMobileFriendly=false,
    isSearchClickTigger=false,
    isGetSeatAvailibity=false,
    onSearch=()=>{

    }}) => {

    const {
        isMobile
    }=useContext(DeviceContext);

    const origins = useSelector(originsSelector);
    const destinations = useSelector(originSupportedDestinationsSelector);
    const cityAliasMap = useMemo(()=>buildCityAliasMap(origins,destinations),[origins,destinations]);
    const filterCityOption = useMemo(()=>cityFilterOption(cityAliasMap),[cityAliasMap]);
    const dispatch=useDispatch();
    const [form] = Form.useForm();
    const searchButtonRef = useRef(null);

    
    useEffect(()=>{
        function call() {
            dispatch(getOriginCities());
          }
          call();
    },[]);

    useEffect(()=>{
        if(isValid(origin)){
            dispatch(getDestinationCities(origin));
        }
    },[])

    useEffect(()=>{
        if(isSearchClickTigger){
            searchButtonRef.current.click();   
        }
    },[]);

    const onOriginChange=(value)=>{
        dispatch(getDestinationCities(value));
    }

    const setLoading =(value)=>{
        dispatch(loadingAction(value));
    }
    const onFinish=(values)=>{
        setLoading(true);
        let origin=values.origin;
        let destination=values.destination;
        let selectedDate=getAPIDateFormat(values.date);
        dispatch(fetchSchedules(origin,destination,selectedDate,isGetSeatAvailibity,true,(fetchedSchedules)=>{
            onSearch(fetchedSchedules,selectedDate,origin,destination);
            setLoading(false);
        }));
    }

    let ValidateToApplyMobileStyles=isMobile&&isMobileFriendly?true:false;

    if(isValid(date)){
        date = moment.parseZone(date);
    }
    return (
        <Row>
            <Form
            onFinish={onFinish}
            form={form}
            initialValues={{origin,destination,date}}
            >
            <Row gutter={16} justify="center" align="middle">
            <Col xs={ValidateToApplyMobileStyles?24:null} sm={ValidateToApplyMobileStyles?24:null}>
                    <Form.Item
                                name="origin"
                                rules={[{ required: true, message: 'Please input your origin!' }]}
                                style={ValidateToApplyMobileStyles?{ marginBottom: "0px" }:{}}

                        >
                            <Select
                                    size="large"
                                    showSearch
                                    placeholder="Select a origin"
                                    onChange={onOriginChange}
                                    filterOption={filterCityOption}
                                    bordered={true}
                                    className="defalut-select-style"
                                >
                                {renderOrigins(origins)}
                                </Select>
                        </Form.Item>
                </Col>
                <Col xs={ValidateToApplyMobileStyles?24:null} sm={ValidateToApplyMobileStyles?24:null}>
                                <Row justify="center">
                                    <Form.Item
                                        style={ValidateToApplyMobileStyles?{ margin: "0px" }:{}}
                                    >
                                        <Button
                                        className="transparentButton"
                                        type="text"
                                        icon={<SwapOutlined className={ValidateToApplyMobileStyles?"transform90Degrees":""}
                                        onClick={()=>{
                                           let {
                                               origin,
                                               destination
                                           } =form.getFieldsValue();
                                           form.setFieldsValue({
                                               origin:destination,
                                               destination:origin
                                           })
                                        }}
                                        />}
                                        >
                                        </Button>
                                    </Form.Item>
                                </Row> 
                                </Col>
                <Col xs={ValidateToApplyMobileStyles?24:null} sm={ValidateToApplyMobileStyles?24:null}>
                        <Form.Item
                                name="destination"
                                rules={[{ required: true, message: 'Please input your destination!' }]}
                        >
                                <Select
                                    size="large"
                                    showSearch
                                    placeholder="Select a destination"
                                    filterOption={filterCityOption}
                                    bordered={true}
                                    className="defalut-select-style"
                                >
                                {renderDestinations(destinations)}
                                </Select>
                        </Form.Item>
                </Col>
                <Col xs={ValidateToApplyMobileStyles?24:null} sm={ValidateToApplyMobileStyles?24:null}>
                        <Form.Item
                                name="date"
                                rules={[{ required: true, message: 'Please input your date!' }]}
                        >
                                <DatePicker className="defalut-picker-style"/>
                        </Form.Item>
                </Col>
                <Col xs={ValidateToApplyMobileStyles?24:null} sm={ValidateToApplyMobileStyles?24:null}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" ref={searchButtonRef}>Search</Button>
                        </Form.Item>
                </Col>
            </Row>
        </Form>
    </Row>
    )
}